import { Component, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../retailer.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CustomTooltip } from 'src/app/features-common/components/tool-tip/tool-tip.component';
import { ViewCommentComponent } from '../manage-retailer/comments/view-comment.component';
import { MatDialog } from '@angular/material/dialog';
const helper = new JwtHelperService();
@Component({
  selector: 'app-retailer-requests',
  templateUrl: './retailer-requests.component.html',
  styleUrls: ['./retailer-requests.component.scss']
})
export class RetailerRequestsComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  searchValue: string = " ";
  columnDefs: any = [];
  defaultColDef: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  userRole: any = '';
  tooltipShowDelay: number;
  frameworkComponents;
  constructor(private retailerService: RetailerService, public dialog: MatDialog,) {
    super();
    const self = this;
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;

    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      tooltipComponent: 'customTooltip',
    };
    this.tooltipShowDelay = 0;
    this.frameworkComponents = { customTooltip: CustomTooltip };

    this.columnDefs = [
      // { field: 'Id', headerName: 'id', width: 0, hide: true, sort: "desc" },
      { field: 'businessName', headerName: 'Business Name', width: 300 },
      { field: 'emailId', headerName: 'Email ID', width: 200 },
      {
        field: 'phoneNumber', headerName: 'Phone Number', width: 200, cellRenderer: (data) => {
          return `+1 ${formatPhoneNumber(data.value)}`
        }
      },
      {
        field: 'createdDttm', headerName: 'Submission Date', width: 200, cellRenderer: (data) => {
          return data.value ? moment(data.value).format("MM/DD/YYYY") : data.value;
        }
      },
      {
        field: 'createdTime', headerName: 'Submission Time', width: 200, cellRenderer: (data) => {
          return data.value ? moment(data.value).format("hh:MM:ss a") : data.value;
        }
      },
      {
        field: 'message', headerName: 'Comments', width: 300, tooltipField: 'message',
        tooltipComponentParams: { color: '#ececec' }, cellRenderer: (data) => {
          return `<span class="mb-0">${data.value} </span>`
        },
        onCellClicked: function (params) {
          self.handleViewMessage(params.data);
        },
      }

    ]
    this.retailerService.getRetailerRequestSubmissions().subscribe(res => {
      if (res['httpcode'] == 200) {
        this.rowData = res['data']
      }
    })
  }


  handleViewMessage(message) {
    // Open a mat dilog to compose message
    const dialogRef = this.dialog.open(ViewCommentComponent, {
      panelClass: "view-message",
      minHeight: "200px",
      maxHeight: "400px",
      width: "50vw",
      data: message.message,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.gridApi.refreshCells();
    });
  }

  ngOnInit(): void {
    super.ngOnInit()
  }
  ngOnDestroy() {
    super.ngOnDestroy()
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: 'BecomeRetailerRequests.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }
      else if (cellParams && cellParams.column.colId === "createdDttm") {
        return moment(cellParams.value).format("MM/DD/YYYY");
      }
      else if (cellParams && cellParams.column.colId === "createdTime") {
        return moment(cellParams.value).format("hh:mm:ss a");
      }
      else return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsCsv(params);
  }


}
function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = (match[1] ? '+1 ' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}
